import { LayoutDirection } from '../../core/rtl/rtl.module';
import { PositionStrategy } from './position/position-strategy';

/**
 * OverlayState is a bag of values for either the initial configuration or current state of an
 * overlay.
 */
export class OverlayState {
  /** Strategy with which to position the overlay. */
  public positionStrategy: PositionStrategy;

  /** Whether the overlay has a backdrop. */
  public hasBackdrop: boolean = false;

  /** Custom class to add to the backdrop **/
  public backdropClass: string = 'rt-overlay-dark-backdrop';

  /** The width of the overlay panel. If a number is provided, pixel units are assumed. **/
  public width: number | string;

  /** The height of the overlay panel. If a number is provided, pixel units are assumed. **/
  public height: number | string;

  /** The min-width of the overlay panel. If a number is provided, pixel units are assumed. **/
  public minWidth: number | string;

  /** The min-height of the overlay panel. If a number is provided, pixel units are assumed. **/
  public minHeight: number | string;

  /** The direction of the text in the overlay panel. */
  public direction: LayoutDirection = 'ltr';

  public disablePointerEvents: boolean = false;

  public zIndex: number = 9000;

  public level: number = 0;

  // TODO(jelbourn): configuration still to add
  // - focus trap
  // - disable pointer events
  // - z-index
}
